up.compiler('#steady_pro_tos_accepted', function (element) {
  const buttons = Array.from(document.querySelectorAll('.js-payment_btn'))

  const setButtonDisabled = () => {
    if (element.checked) {
      buttons.forEach(button => button.removeAttribute('disabled'))
    } else {
      buttons.forEach(button => button.setAttribute('disabled', 'disabled'))
    }
  }

  setButtonDisabled()

  element.addEventListener('change', function () {
    setButtonDisabled()
  })
})
